import { render, staticRenderFns } from "./AcceleratorDocs.vue?vue&type=template&id=b387916a&scoped=true&"
import script from "./AcceleratorDocs.vue?vue&type=script&lang=js&"
export * from "./AcceleratorDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b387916a",
  null
  
)

export default component.exports